import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router';
import { withRouter } from 'react-router';
import LinkButton from './LinkButton/LinkButton';
import './styles/SubPageNavigation.scss';

const SubPageNavigation = ({ links, listClassName, location, forceAnchor }) => (links.length !== 0 || typeof links === 'undefined') ? (
  <div className='page-menu'>
    <span>
      <ul className={listClassName || 'nav nav-pills flat-pill'}>
        {links.map((link, index) => {
          const content = link[0];
          const path = link[1];
          const isEmbed = link[3] || false;
          const hasSubLinks = link[2] && link[2].length > 0;
          const isFullUrl = path.includes('://');
          let linkComponent;

          if (isFullUrl || isEmbed) {
            linkComponent = <a href={path} target='_blank'>{content}</a>;
          } else if (hasSubLinks) {
            linkComponent = <HoverMenu content={content} subLinks={link[2]} />;
          } else if (forceAnchor) {
            linkComponent = <a href={path}>{content}</a>;
          } else {
            linkComponent = <Link to={path}>{content}</Link>;
          }

          return (
            <li key={index} className={location.pathname === path ? 'active' : ''}>
              {linkComponent}
            </li>
          );
        })}
      </ul>
    </span>
  </div>
) : null;

const HoverMenu = ({ content, subLinks }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHoverSupported, setIsHoverSupported] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const checkHover = window.matchMedia('(hover: hover)').matches;
    setIsHoverSupported(checkHover);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, []);

  const handleMenuToggle = (event) => {
    if (!isHoverSupported) {
      event.stopPropagation();
      setIsOpen((prev) => !prev);
    }
  };

  const handleMouseEnter = () => {
    if (isHoverSupported) {
      setIsOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (isHoverSupported) {
      setIsOpen(false);
    }
  };

  return (
    <div
      className={`hover-menu-area${isOpen ? ' show' : ''}`}
      ref={menuRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <LinkButton
        content={content}
        className='hover-menu-button'
        onClick={handleMenuToggle}
      />
      <div className={`hover-menu-dropdown${isOpen ? ' show' : ''}`}>
        {subLinks.map((subLink) => (
          <a key={subLink[1]} href={subLink[1]} className='hover-menu-item'>
            {subLink[0]}
          </a>
        ))}
      </div>
    </div>
  );
};

export default withRouter(SubPageNavigation);
